import { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { fetchEventById } from '../../lib/eventsApi';
import { fetchAttachments } from '../../lib/attachmentsApi';
import { usePageBackground } from '../../lib/cmsUtils';
import defaultHero from '../../assets/main.svg';

import './EventDetail.scss';

export default function EventDetail() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const bgImage = usePageBackground('events', defaultHero);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const ev = await fetchEventById(id);
      if (ev.status !== 'published') throw new Error('Event not found');
      setEvent(ev);
      setAttachments(await fetchAttachments({ eventId: id }));
    } catch (err) {
      setError(err.message || 'Event not found');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  if (loading) {
    return (
      <div className="eventDetail">
        <Navbar />
        <p className="eventDetail__status">Loading…</p>
      </div>
    );
  }

  if (error || !event) {
    return (
      <div className="eventDetail">
        <Navbar />
        <main className="eventDetail__container">
          <p className="eventDetail__status eventDetail__status--error">{error}</p>
          <Link to="/events" className="eventDetail__back">← Back to events</Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="eventDetail">
      <Navbar />
      <header className="eventDetail__hero" style={{ backgroundImage: `url(${event.image_url || bgImage})` }} />
      <article className="eventDetail__container">
        <Link to="/events" className="eventDetail__back">← Back to events</Link>
        <h1>{event.title}</h1>
        <time dateTime={event.date}>{new Date(event.date).toLocaleString()}</time>
        {event.location && <p className="eventDetail__location">{event.location}</p>}
        {event.description && <div className="eventDetail__desc">{event.description}</div>}
        {event.external_url && (
          <a href={event.external_url} target="_blank" rel="noreferrer" className="eventDetail__external">
            Learn more →
          </a>
        )}
        {attachments.length > 0 && (
          <section className="eventDetail__attachments">
            <h2>Downloads</h2>
            <ul>
              {attachments.map((f) => (
                <li key={f.id}>
                  <a href={f.file_url} target="_blank" rel="noreferrer" download={f.file_name}>
                    {f.file_name}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        )}
      </article>
      <Footer />
    </div>
  );
}
